import { AuthGuard, CrudOp, tmmAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredProjectParam, useRequiredSubprojectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { getTargetMaterialMode, importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const TargetMaterialView: FC = () => {
  const brand = useRequiredProjectParam("brand");
  const projectId = useRequiredProjectParam("projectId");
  const subprojectId = useRequiredSubprojectParam("subprojectId");
  const tmmId = useRequiredSubprojectParam("tmmId");
  const targetMaterialMode = getTargetMaterialMode(brand);
  return (
    <AuthGuard authScope={tmmAuthScope} crudOp={CrudOp.READ} project={projectId}>
      <Suspense><LazyTargetMaterialView projectId={projectId} subprojectId={subprojectId} tmmId={tmmId} targetMaterialMode={targetMaterialMode}/></Suspense>
    </AuthGuard>
  );
};

const LazyTargetMaterialView = lazy(importView(
  () => import("../components/TargetMaterialView"),
  (it) => it.TargetMaterialView,
));
